export default "__VITE_ASSET__16e26f7d__"